import React from 'react';
import Autosuggest from 'react-autosuggest';


export default class SuggestInput extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            suggestions: []
        };
    }

    onChange = (event, obj) => {
        if(this.props.errors) {
            let newErrors = this.props.errors;
            newErrors[this.props.field] = false;

            this.props.setErrors(newErrors);
        }

        this.props.onChange({
            value: obj.newValue,
        });
    };

    onSuggestionSelected = (event, {suggestion}) => {
        this.props.onChange(suggestion);
    };

    onSuggestionsFetchRequested = ({value}) => {
        this.props.getData(value).then(values => {
            this.setState({
                suggestions: values
            });
        });
    };

    onSuggestionsClearRequested = () => {
        this.setState({
            suggestions: []
        });
    };

    getSuggestionValue = (suggestion) => {
        return suggestion.value;
    };

    render() {
        const {value, suggestions} = this.state;
        let classNames = ["product-request__input"];
        if(this.props.errors && this.props.errors[this.props.field]) {
            classNames.push("empty");
        }

        const inputProps = {
            placeholder: this.props.placeholder,
            value: this.props.value,
            onBlur: this.onBlurHandler,
            onChange: this.onChange,
            className: classNames.join(" "),
            autoComplete: "off",
            disabled: this.props.disalbed ?? false,
            /*onBlur: e => {
                console.log(e.target.value);
                console.log(this.state);
            }*/
        };

        return (
            <Autosuggest
                suggestions={suggestions}
                onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                onSuggestionSelected={this.onSuggestionSelected}
                getSuggestionValue={this.getSuggestionValue}
                renderSuggestion={value => value.value}
                inputProps={inputProps}
            />
        );
    }
};